
import { instantiate } from './MegaYatzyNextGen-app-web.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


